module.exports = __webpack_public_path__ + "static/media/pneumatic.919061fe.svg";